// assets
import DollarOutlined from '@ant-design/icons/DollarOutlined';

const icons = { DollarOutlined };

// ==============================|| MENU ITEMS - PAYMENTS ||============================== //

const payments = {
  id: 'payments',
  title: 'Payments',
  type: 'group',
  url: '/payments',
  icon: icons.DollarOutlined,
  permission: {
    module: 'payments',
    level: 10 // View permission required
  }
};

export default payments;
